/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { generateSimplestList } from '@touchplan/common';
import { DefaultSplitDataRenderType, SplitData } from '@touchplan/common';

export interface ColorFields {
	color: string;
	id: string;
}

export class Color extends SplitData<ColorFields, DefaultSplitDataRenderType> {
	protected useInPlace = true;
	protected attributeList = Object.assign(generateSimplestList(['color', 'id']));

	constructor(id: string) {
		super(id, DefaultSplitDataRenderType.database);
	}
}
